import {
  clearLoading,
  startLoading,
  startLoadingCrops,
  startLoadingFarms,
  startLoadingSpecifications,
  startLoadingVarieties,
  stopLoading,
  stopLoadingCrops,
  stopLoadingFarms,
  stopLoadingSpecifications,
  stopLoadingVarieties,
} from './loading.actions'
import { Action, ActionReducer, createReducer, on } from '@ngrx/store'

export interface LoadingState {
  isLoading: boolean
  isLoadingFarms?: boolean
  isLoadingCrops?: boolean
  isLoadingVarieties?: boolean
  isLoadingSpecifications?: boolean
}

export const initialLoadingState: LoadingState = {
  isLoading: false,
  isLoadingFarms: false,
  isLoadingCrops: false,
  isLoadingVarieties: false,
  isLoadingSpecifications: false,
}

export const loadingReducer: ActionReducer<LoadingState, Action> = createReducer(
  initialLoadingState,
  on(startLoading, (state) => ({ ...state, isLoading: true })),
  on(stopLoading, (state) => ({ ...state, isLoading: false })),
  on(startLoadingFarms, (state) => ({ ...state, isLoadingFarms: true })),
  on(stopLoadingFarms, (state) => ({ ...state, isLoadingFarms: false })),
  on(startLoadingCrops, (state) => ({ ...state, isLoadingCrops: true })),
  on(stopLoadingCrops, (state) => ({ ...state, isLoadingCrops: false })),
  on(startLoadingVarieties, (state) => ({ ...state, isLoadingVarieties: true })),
  on(stopLoadingVarieties, (state) => ({ ...state, isLoadingVarieties: false })),
  on(startLoadingSpecifications, (state) => ({ ...state, isLoadingSpecifications: true })),
  on(stopLoadingSpecifications, (state) => ({ ...state, isLoadingSpecifications: false })),
  on(clearLoading, () => initialLoadingState),
)
